import classes from "../questions.module.css";
import {ReactComponent as DELETE} from "../../images/trash_red.svg";
import {
    handleAddAnswer,
    handleDeleteAnswer,
    handleUpdateAnswer
} from "../../utils/questionUpdate";
import {
    ADD_ANOTHER_ANSWER_TEXT, CORRECT_ANSWER_TEXT, ENTER_CORRECT_RESPONSE_TEXT, GRADE_SCHEMA,
    MC_ANSWER_LENGTH,
    PREVIEW_TEXT,
} from "../../utils/constants";
import React, {Fragment} from "react";
import YuJaButton from "../../components/standardization/YuJaButton";
import {ReactComponent as PlusIcon} from "../../images/plus.svg";

export default function FITBAnswerNew({
                                          gradeSchema,
                                          questions,
                                          setQuestions,
                                          selectedQuestion,
                                          editorState,
                                          setEditorState,
                                          compositeDecorator,
}) {

    const {queTitle, correctAnswers={}, serialNo, weightage} = selectedQuestion;
    const gradeEnable = gradeSchema !== GRADE_SCHEMA.UNGRADED.key && !!weightage;


    if (!gradeEnable || !correctAnswers || Object.keys(correctAnswers).length === 0) {
        return <></>;
    }

    return (
        <>
            <span style={{fontWeight: "600", marginTop: 5}}>{CORRECT_ANSWER_TEXT}</span>
            {Object.keys(correctAnswers).map((key, index) => (
                <Fragment key={index}>
                    <div  className={classes.FITBCorrectAnswerContainer}>
                        <span className={classes.FITBBlankNameBox}>
                            <span style={{flex: 1, minWidth: 0, overflowWrap: "break-word", textAlign: "center"}}>
                                {key}
                            </span>
                        </span>
                        <div className={classes.FITBAnswerInputList}>
                            {correctAnswers[key].map((value, idx) => (
                                <div key={idx} className={classes.FITBAnswerInputBox}>
                                    <div className={classes.FITBAnswerInputWrapper}>
                                        <input
                                            placeholder={ENTER_CORRECT_RESPONSE_TEXT}
                                            value={value}
                                            maxLength={100}
                                            onChange={(e) => {
                                                handleUpdateAnswer(key, idx, e.target.value, correctAnswers, serialNo - 1, questions, setQuestions)
                                            }}
                                        />
                                        <span className={classes.FITBAnswerCharacterCountBox}>
                                            {value.length}/{MC_ANSWER_LENGTH}
                                        </span>
                                    </div>

                                    <span
                                        tabIndex={0}
                                        role={"button"}
                                        aria-label={`Delete answer`}
                                        className={classes.FITBDeleteAnswerBox}
                                        onClick={() => handleDeleteAnswer(key, idx, correctAnswers, serialNo - 1,
                                            questions, setQuestions, editorState, setEditorState, compositeDecorator
                                        )}
                                    >
                                    <DELETE/>
                                </span>
                                </div>
                            ))}
                        </div>
                    </div>

                    <YuJaButton
                        title={PREVIEW_TEXT}
                        onClick={() => handleAddAnswer(key, correctAnswers, serialNo - 1, questions, setQuestions)}
                        style={{
                            width: 180,
                            height: 35,
                            alignItems: "center",
                            justifyContent: "center",
                            display: "flex",
                            whiteSpace: "nowrap",
                            alignSelf: "end"
                        }}
                    >
                        <PlusIcon style={{width: 15, height: 15, marginRight: 2}}/>{ADD_ANOTHER_ANSWER_TEXT}
                    </YuJaButton>
                </Fragment>


            ))}
        </>
    );
}